import BigNumber from 'bignumber.js';
import { Address, getContract, PublicClient } from 'viem';

import IERC20Abi from '../abi/IERC20';
import { convertFromWei } from '../utils';

export interface IGetAllowanceResult {
  allowance: BigNumber;
  spender: Address;
}

export async function getAllowance(
  client: PublicClient,
  data: { userAddress: Address; spender: Address; tokenAddress: Address },
): Promise<IGetAllowanceResult> {
  const { userAddress, spender, tokenAddress } = data;

  const tokenContract = getContract({
    address: tokenAddress,
    abi: IERC20Abi,
    client,
  });

  const allowance: bigint = await tokenContract.read.allowance([
    userAddress,
    spender,
  ]);

  return {
    allowance: convertFromWei(allowance),
    spender,
  };
}
